import { isBase64WithinSizeLimit, MAX_FILE_SIZE_BYTES } from "./fileValidation";

const loadImage = (dataUrl: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = dataUrl;
  });

// Progressively lowers JPEG quality, then scale, until under maxBytes or the floors are hit.
// Returns the original dataUrl unchanged if it's already within the limit.
export async function compressBase64Image(
  dataUrl: string,
  maxBytes: number = MAX_FILE_SIZE_BYTES,
  minQuality = 0.3,
  minScale = 0.4
): Promise<string> {
  if (isBase64WithinSizeLimit(dataUrl, maxBytes)) return dataUrl;

  const img = await loadImage(dataUrl);
  let quality = 0.9;
  let scale = 1;
  let result = dataUrl;

  while (!isBase64WithinSizeLimit(result, maxBytes) && (quality > minQuality || scale > minScale)) {
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(img.width * scale));
    canvas.height = Math.max(1, Math.round(img.height * scale));
    const ctx = canvas.getContext("2d")!;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    result = canvas.toDataURL("image/jpeg", quality);

    if (quality > minQuality) quality = Math.max(minQuality, quality - 0.15);
    else scale = Math.max(minScale, scale - 0.15);
  }

  return result;
}
